module.exports = "<ctx-app-panel-toolbar app-title=\"{{::'accessDenied.dialog.title'|translate}}\">\n    <div class=\"container-fluid\">\n        <h1 class=\"text-center\">{{ 'accessDenied.dialog.title'|translate }}</h1>\n    </div>\n</ctx-app-panel-toolbar>"


//////////////////
// WEBPACK FOOTER
// ./src/azurebackup/views/accessDenied/accessDenied.template.html
// module id = 559
// module chunks = 0